import * as types from './user-groups.types';

export const userGroupsPageSelectors: types.IUserGroupsPageSelectors = {
  selectUserGroupIds: (state) => state.page.userGroups.userGroupIds,
};
